function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
import unionBy from 'lodash/unionBy';
import differenceBy from 'lodash/differenceBy';
import { UNSUBSCRIBE_LEVEL2, GET_ALL_LEVEL_2_DATA, LEVEL_2_UPDATES, REQUEST_LEVEL_2_DATA } from '../actions/level2Actions';
var initialState = getDefaultState();
var descendingPrice = function descendingPrice(a, b) {
  return b.Price - a.Price;
};
export default function level2() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case REQUEST_LEVEL_2_DATA:
      return Object.assign({}, state, {
        fetching: true
      });
    case GET_ALL_LEVEL_2_DATA:
      return handleGetAllLevel2Data(state, payload);
    case LEVEL_2_UPDATES:
      return handleLevel2Updates(state, payload);
    case UNSUBSCRIBE_LEVEL2:
      return getDefaultState();
    default:
      {
        return state;
      }
  }
}
var handleGetAllLevel2Data = function handleGetAllLevel2Data(state, payload) {
  var data = mapOrders(payload);
  return Object.assign({}, state, {
    sell: data.sell.sort(descendingPrice),
    buy: data.buy.sort(descendingPrice),
    fetching: false
  });
};
function handleLevel2Updates(state, payload) {
  var updates = mapOrders(payload);
  return Object.assign({}, state, {
    buy: mergeOrders(state.buy, updates.buy),
    sell: mergeOrders(state.sell, updates.sell),
    short: [].concat(_toConsumableArray(state.short), _toConsumableArray(updates.short)),
    unknown: [].concat(_toConsumableArray(state.unknown), _toConsumableArray(updates.unknown))
  });
}
var deleteType = 2;
var mergeOrders = function mergeOrders(state, updates) {
  var updatesToDelete = [];
  var updatesToMerge = [];
  updates.forEach(function (update) {
    if (update.ActionType === deleteType) {
      var position = updatesToMerge.findIndex(function (item) {
        return item.Price === update.Price;
      });
      if (position !== -1) {
        updatesToMerge = updatesToMerge.filter(function (i) {
          return i.Price !== update.Price;
        });
      }
      updatesToDelete.push(update);
    } else {
      updatesToMerge.push(update);
    }
  });
  var filteredState = differenceBy(state, updatesToDelete, function (x) {
    return x.Price;
  });
  return unionBy(
  /**
   * @NOTE
   *  this sorting is needed to give precedence to newer updates,
   *  when Level2UpdateEvent contains multiple ActionType=Update entries for same price level.
   */
  updatesToMerge.sort(function (a, b) {
    return b.UpdateId - a.UpdateId;
  }), filteredState, function (x) {
    return x.Price;
  }).sort(descendingPrice);
};
function getDefaultState() {
  return {
    buy: [],
    sell: [],
    short: [],
    unknown: [],
    fetching: true
  };
}
function mapOrders(data) {
  var result = {
    buy: [],
    sell: [],
    short: [],
    unknown: []
  };
  data.forEach(function (update) {
    switch (update.Side) {
      case 0:
        result.buy.push(update);
        break;
      case 1:
        result.sell.push(update);
        break;
      case 2:
        result.short.push(update);
        break;
      default:
        result.unknown.push(update);
        break;
    }
  });
  return result;
}